import * as React from 'react';
import * as styles from './styles.css';

import { IValuationFiltersProps } from '../../types';
import { TRefWrapper } from '../../../../containers/Scrolling';

export interface IValuationFilterDesktopProps extends IValuationFiltersProps {
  refWrapper: TRefWrapper;
}

export const ValuationFiltersDesktop: React.FC<IValuationFilterDesktopProps> = ({
  mainFiltersWidget,
  valuationFiltersSubmit,
  refWrapper,
}) => {
  return refWrapper(
    <div data-testid="ValuationFiltersDesktop" className={styles['valuation_header']}>
      <div className={styles['title-container']}>
        <h1 className={styles['title']}>Оцените квартиру бесплатно</h1>
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['header_container']}>
          <div className={styles['wrapper_label']} data-testid="mainFiltersWidget">
            {mainFiltersWidget}
            <div className={styles['suburban_info']} />
          </div>
          <div className={styles['wrapper_button']} data-testid="valuationFiltersSubmit">
            {valuationFiltersSubmit}
          </div>
        </div>
      </div>
    </div>,
  );
};

ValuationFiltersDesktop.displayName = 'ValuationFiltersDesktop';
